import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../stores/NavigateStore";

export const useStyles = makeStyles(() => ({
    appBar: {
        height: topHeight + 'px !important',
        padding: '0 24px !important',
        display: 'flex !important',
        flexDirection: 'row !important',
        alignItems: 'center !important',
        justifyContent: 'flex-start !important',
        boxSizing: 'border-box !important',
        background: '#F9F9F9 !important',
        boxShadow: 'none !important'
    },
    title: {
        fontSize: '1.5rem !important',
        color: '#10121C !important',
        fontWeight: '700 !important'
    },
    profileIcon: {
        '&.MuiIconButton-root': {
            padding: 0,
            marginLeft: 15,
        }
    },
    formControl: {
        '&.MuiFormControl-root ': {
            margin: 0,
        },
        '& .MuiSelect-select': {
            width: 150,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing: 'border-box',
            color: '#777',
            letterSpacing: '-0.5px',
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select': {
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
}));

